<template>
  <span class="text-white px-1 rounded text-sm whitespace-no-wrap" :class="'bg-'+color()">
    {{ label() }}
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        required: false,
      },
    },
    methods: {
      color: function() {
        switch(this.value) {
          case true:
            return 'green-500';
          case false:
            return 'red-500'
          default:
            return 'gray-500';
        }
      },
      label: function() {
        switch(this.value) {
          case true:
            return 'ja';
          case false:
            return 'nein'
          default:
            return 'keine Angabe';
        }
      },
    }
  }
</script>